import script from "./ScheduleStart.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleStart.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleStart.vue?vue&type=style&index=0&id=265a0c6b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-265a0c6b"]])

export default __exports__